import { render } from "./footer-photos-list.vue?vue&type=template&id=162c0f4a"
import script from "./footer-photos-list.vue?vue&type=script&lang=js"
export * from "./footer-photos-list.vue?vue&type=script&lang=js"

import "./footer-photos-list.vue?vue&type=style&index=0&id=162c0f4a&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__